import Vue from "vue";
import Cookies from "js-cookie";
import Ajax from "@/ajax";
import store from "@/store";
import VueRouter from "vue-router";
import Home from "@/pages/home";
import User from "@/pages/user";
import Yun from "@/pages/yun";
import Order from "@/pages/order";
import Invite from "@/pages/invite";
import Shop from "@/pages/shop";
import News from "@/pages/news";
import GameLibrary from "@/pages/games";
import YunGames from "@/pages/yungames";
import deviceAuthorize from "@/pages/authorize";
import LayoutMain from "@/components/layout/LayoutMain";
import myPopup from "../mypopup";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {
      name: "home",
    },
    children: [
      ...Home,
      ...User,
      ...Yun,
      ...Order,
      ...Invite,
      ...Shop,
      ...News,
      ...GameLibrary,
      ...YunGames,
      ...deviceAuthorize,
    ],
    component: LayoutMain,
  },
  {
    path: "/promotion",
    name: "promotion",
    component: () => import("@/pages/Promotion.vue"),
  },
  {
    path: "/game/promotion",
    name: "game.promotion",
    component: () => import("@/pages/GamePromotion.vue"),
  },
  {
    path: "/*",
    component: () => import("@/pages/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
Vue.prototype.$bus = new Vue();

router.beforeEach(async (to, from, next) => {
  const isWxApp = to.query.isWxApp;
  if (isWxApp) {
    //泡泡地址嵌入微信微信小程序 若是微信小程序则增加标识
    store.commit("setIsWxApp", true);
  }
  // console.log("isWxApp", store.getters.state.isWxApp);
  let accessToken;
  let refreshToken;
  ({ accessToken, refreshToken } = store.getters.state);
  if (refreshToken && !accessToken) {
    await store.dispatch("refreshToken", refreshToken);
  }
  const searchParams = new URLSearchParams(window.location.search);
  const platid = searchParams.get("platid");
  if (platid) {
    // console.log(platid);
    let expires = new Date();
    expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 24 小时后的时间
    Cookies.set("newPlatId", platid, { expires: expires });
  }
  // console.log(Cookies.get("newPlatId"));

  if (
    to.name != "user.message" &&
    to.name != "user.customerservice" &&
    to.name != "promotion" &&
    to.name != "game.promotion" &&
    to.name != "invite.register" &&
    to.name != "invite.detail" &&
    to.name != "shop.goodsList" &&
    to.name != "shop.detail" &&
    to.name != "user.weChatWarn"
  ) {
    if (store.getters.isLogin) {
      // console.log("登录成功");
    } else {
      if (store.getters.state.isWxApp) {
        next({
          query: to.query, // 保留原本的查询参数
          replace: true,
        });
      } else {
        // console.log("登录");
        if (to.path != "/home" && to.path != "/premium") {
          next({
            path: "/home",
            query: to.query, // 保留原本的查询参数
            replace: true,
          });
        } else {
          myPopup({
            onSuccess: () => {},
          });
        }
      }
      // localStorage.removeItem("signInShow")
    }
  }

  Vue.prototype.$bus.$off("refreshPage");
  Vue.prototype.$bus.$off("empty");
  next();
});
export default router;
